
import React from 'react';
import { useSelector } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getAttributeById } from '../../common/common/iskn/dataDefinition';
import { DEFINITION_PAR } from '../../common/common/iskn/par';

import { getParamsValues  } from '../../reducers/search';

import FilterBase from './FilterBase';
import FilterItemText from './FilterItemText';
import FilterItemValues from './FilterItemValues';

const FilterContent = () => {

    const paramsValues = useSelector(state => getParamsValues(state.search));

    return (
        <FilterBase
            objectType={DEFINITION_PAR.objectType}
            items={[
                <FilterItemValues
                    definition={{
                        id: 'katuze_kod',
                        title: 'Katastrální území',
                        values: paramsValues.katuze.map(item => [item.kod, item.nazev])
                    }}
                />,

                <FilterItemText definition={getAttributeById(DEFINITION_PAR, 'parcela')} />,
                <FilterItemValues definition={getAttributeById(DEFINITION_PAR, 'par_type')} />,
                <FilterItemValues definition={getAttributeById(DEFINITION_PAR, 'drupoz_kod')} />,
            ]}
        />
    );
}

const ParcelFilter = () => {
    return (
        <Stack>
            <FilterContent />
        </Stack>
    );
}

export default ParcelFilter;
